import React, { forwardRef, ForwardRefRenderFunction, useMemo } from "react";
//#region redux
//#endregion
//#region types
import { BaseFormViewComponentProps, FormHandles } from "models/propTypes/genericFormProps";
import { UploadedFile } from "models/utilTypes/fileUtilsTypes";
import { ArticleFormTypes } from "models/formTypes";
import { FileEnums } from "models/enums";
import { TranslationKeys } from "translations";
import { FileUploaderProps, SelectInputItemProps, SelectInputProps } from "models/propTypes/wintFormPropsTypes";
//#endregion
//#region components
import {
  WintForm,
  VerticalFormField,
  useWintForm,
  SelectInput,
  FileUploader,
  InlineLabel,
} from "components/common/wintForms";
import { Grid } from "@mui/material";
//#endregion
import { LocalizationHelperInstance, CsvImportHelper, FileHelper } from "utils/helpers";

const ImportArticleForm: ForwardRefRenderFunction<FormHandles, BaseFormViewComponentProps> = (props, ref) => {
  const { wintFormProps, connect, values, setValues, formState } = useWintForm<ArticleFormTypes.ImportArticle>({
    formRef: ref,
    defaultValues: props.defaultValues,
    validationSchema: props.validationSchema,
    handleSubmit: props.handleSubmit,
  });

  const headersObject = useMemo((): SelectInputItemProps[] => {
    if (values.csvUpload?.length) {
      const fileContent = CsvImportHelper.decodeBase64(values.csvUpload[0].data);
      try {
        const { headers } = CsvImportHelper.importCSV(fileContent);
        return headers.map((item) => ({ value: FileHelper.getUTF8Encoding(item), label: item }));
      } catch (e: any) {
        formState.setFieldError(
          "csvUpload",
          e.message ?? LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Validations.Invalid)
        );
      }
    }
    return [];
  }, [values.csvUpload]);

  const onFileUploaded = (value: UploadedFile[]) => {
    formState.resetForm();
    setValues({ csvUpload: value });
  };

  const csvUploadProps = connect("csvUpload");

  return (
    <WintForm {...wintFormProps}>
      <VerticalFormField<FileUploaderProps>
        Component={FileUploader}
        singleSelection
        maxFileCount={1}
        allowedTypes={[FileEnums.ContentTypes.CSV]}
        {...csvUploadProps}
        showMainLabel
        setValue={onFileUploaded}
        descriptionText={
          headersObject.length
            ? undefined
            : LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Article.UploadArticlesDescription)
        }
      />
      {headersObject.length ? (
        <Grid container marginTop={2}>
          <InlineLabel
            columns
            descriptionText={LocalizationHelperInstance.getFormattedMessage(
              TranslationKeys.Article.UploadMappingSectionDescription
            )}
          >
            {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Article.UploadMappingSectionTitle)}
          </InlineLabel>
          <VerticalFormField<SelectInputProps>
            Component={SelectInput}
            {...connect("name")}
            label={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Name)}
            items={headersObject}
          />
          <VerticalFormField<SelectInputProps>
            Component={SelectInput}
            {...connect("unit")}
            label={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Unit)}
            items={headersObject}
            optional
            descriptionText={LocalizationHelperInstance.getFormattedMessage(
              TranslationKeys.Article.UploadUnitDecription
            )}
          />
          <VerticalFormField<SelectInputProps>
            Component={SelectInput}
            {...connect("standardPrice")}
            label={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.StandardPrice)}
            items={headersObject}
            descriptionText={LocalizationHelperInstance.getFormattedMessage(
              TranslationKeys.Article.UploadPriceDecription
            )}
          />
          <VerticalFormField<SelectInputProps>
            Component={SelectInput}
            {...connect("vat")}
            label={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.VAT)}
            items={headersObject}
            descriptionText={LocalizationHelperInstance.getFormattedMessage(
              TranslationKeys.Article.UploadVatDecription
            )}
          />

          <VerticalFormField<SelectInputProps>
            Component={SelectInput}
            {...connect("euVatProductType")}
            label={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Article.EuVatProductType)}
            items={headersObject}
            optional
            descriptionText={LocalizationHelperInstance.getFormattedMessage(
              TranslationKeys.Article.UploadEuVatTypeDecription
            )}
          />
        </Grid>
      ) : (
        <></>
      )}
    </WintForm>
  );
};

export default forwardRef(ImportArticleForm);
